/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FormTechnicalVisitAliases {
  FETCH_QUESTIONS = 'fetch-questions',
  HPMS_FORM_TECHNICAL_VISIT = 'hpms-form-technical-visit',
  LAYOUT = 'layout',
  PANEL = 'panel',
}
export { FormTechnicalVisitAliases };
